module.exports = __webpack_public_path__ + "img/help-active.6e24ecae.svg";